import {Property} from "./property";

export class AuthorityData {
  signingUrl: string;
  signingDate: string;
  person: string;
  company:string;
  interest: string;
  dauer:string;
  properties: Array<Property>;


  constructor(signingUrl: string, signingDate: string, person: string, company: string, dauer:string,interest: string, properties: Array<Property>) {
    this.signingUrl = signingUrl;
    this.signingDate = signingDate;
    this.person = person;
    this.properties = properties;
    this.interest = interest;
    this.company = company;
    this.dauer = dauer;
  }

}
